import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import CardRow from 'design-system/CardRow';
import { Button, rem, Spacer } from 'design-system';
import { formatAmount } from 'utils/formatting';
const InitialInvestmentFeesModalContent = () => {
    const onClose = useCallback(() => {
        Modal.hide();
    }, []);
    return (<>
      <Spacer h={16}/>
      <View style={styles.modalContainer}>
        <Text TextThin-14 Secondary centered>
          Estimated one-off costs for this investment.
        </Text>
      </View>
      <Spacer h={12}/>
      <CardRow small smallPadding title="Transaction cost" numberInfo info={formatAmount(0, 'GBP', 2)}/>
      <CardRow small smallPadding title="Incidental cost" numberInfo info={formatAmount(0, 'GBP', 2)}/>
      <CardRow small numberInfo smallPadding info={formatAmount(0, 'GBP', 2)} title={<Text Text-14>Total costs</Text>}/>
      <Spacer h={32}/>
      <Button brand title="Okay" onPress={onClose}/>
    </>);
};
const InitialInvestmentFeesModal = {
    show: () => {
        Modal.show(<InitialInvestmentFeesModalContent />, {
            containerStyle: styles.modal,
            title: 'Fees',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    modalContainer: {
        paddingHorizontal: rem(16),
    },
});
export default InitialInvestmentFeesModal;
